module.exports = __webpack_public_path__ + "img/bank1.e274a4e9.png";